import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  Modal,
  ActivityIndicator,
  ScrollView,
  RefreshControl,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useContext, useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import FowardFlatArrow from "../../icons/FowardFlatArrow";

import { useNavigation } from "@react-navigation/native";

import useAuth from "../../hooks/useAuth";
import AppContext from "../../context/AppContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import PasswordIcon from "../../icons/PasswordIcon";
import GiveawayIcon from "../../icons/GiveawayIcon";
import SupportIcon from "../../icons/SupportIcon";
import MyCityState from "../signInScreen/MyCityState";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import NoticeAlertComp from "../../alertComp/NoticeAlertComp";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import UsernamePasswordTransactCode from "./UsernamePasswordTransactCode";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const SettingsPage = () => {
  const axiosPrivate = useAxiosPrivate();

  const { isLoading, logOut } = useContext(AppContext);

  // const { username, myCity, firstname, lastname, phonenumber, email, image, hasDVA, isVerifiedForPayment } = useAuth()

  const navigate = useNavigation();

  const [showMyCityState, setShowMyCityState] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [showUsernamePasswordTransactCode, setShowUsernamePasswordTransactCode] = useState(false);

  const checkForExistingPasscode = async () => {
    //check if user has set passcode or not
    try {
      setIsLoading2(true);
      const response = await axiosPrivate.get("/isPasscode/isPasscode");
      if ((response.status === 200 || response.status === 201) && response.data?.hasPasscode) {
        //console.log('PASSCODE:', response.data?.hasPasscode)
        setShowUsernamePasswordTransactCode(true);
      } else {
        //console.log('me herersns', response.data?.message)
        setErrorMessage(response.data?.message || "You have not set any transaction code yet");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
        const errorMessages =
          error.response.data?.error || error.response.data?.message || "Something went wrong";
        setErrorMessage(errorMessages);
        setIsErrorCompVisible(true);
      }
    } finally {
      setIsLoading2(false);
    }
  };

  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size={"large"} />
      </View>
    );
  }

  return (
    <View style={styles.profileContainer2}>
      <TouchableOpacity style={styles.profileDataContainer} onPress={() => setShowNotice(true)}>
        <View style={styles.profileDataSubContainer}>
          <PasswordIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Password reset </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.profileDataContainer}
        onPress={() => setShowMyCityState(true)}
      >
        <View style={styles.profileDataSubContainer}>
          <GiveawayIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Change your city </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>

      <TouchableOpacity style={styles.profileDataContainer} onPress={checkForExistingPasscode}>
        <View style={styles.profileDataSubContainer}>
          <SupportIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Reset transaction code </Text>
            {isLoading2 ? (
              <ActivityIndicator color={Colours.PRIMARY} size={"small"} />
            ) : (
              <FowardFlatArrow color={Colours.PRIMARY} />
            )}
          </View>
        </View>
      </TouchableOpacity>

      <Modal
        animationType="fade"
        visible={showMyCityState}
        onRequestClose={() => setShowMyCityState(false)}
      >
        <TopHeaderComponent
          headerText={"Change your city"}
          hideScreen={() => setShowMyCityState(false)}
        />
        {/* <ScrollView contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}> */}
        <MyCityState fromSettings={true} setShowMyCityState={setShowMyCityState} />
        {/* </ScrollView> */}
      </Modal>

      <Modal visible={showNotice} transparent={true} animationType="fade">
        <NoticeAlertComp
          fromSettings={true}
          message={'You will be logged out, then click "Forgot Password" to reset your password'}
          onCancel={() => setShowNotice(false)}
          onClose={() => {
            setShowNotice(false);
            logOut();
          }}
        />
      </Modal>

      <Modal
        visible={showUsernamePasswordTransactCode}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setShowUsernamePasswordTransactCode(false)}
      >
        <UsernamePasswordTransactCode
          hideModal={() => setShowUsernamePasswordTransactCode(false)}
          forTransactionCodeSetup={true}
        />
      </Modal>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  profileContainer2: {
    padding: dynamicSpacing(30),
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
  nameTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(16),
    marginTop: dynamicSpacing(10),
    fontFamily: "Sen-Bold",
  },
  nameTxt2: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    marginTop: dynamicSpacing(3),
    fontFamily: "Sen-Regular",
  },
  emailTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Medium",
  },
  errorMessageTxt: {
    color: "white",
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
  },
  textTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  profileHeaderContainer2: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    height: dynamicSize(200),
  },
  userImage2: {
    width: dynamicSize(100),
    height: dynamicSize(100),
    borderRadius: dynamicSize(99),
  },
  profileDataContainer: {
    display: "flex",
    backgroundColor: "white",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  errorMessage: {
    display: "flex",
    backgroundColor: "pink",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  profileDataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(243),
  },
  amountForward: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
});

export default SettingsPage;
